import { render, staticRenderFns } from "./QuestionWritingText.vue?vue&type=template&id=6ad94bfd"
import script from "./QuestionWritingText.vue?vue&type=script&lang=js"
export * from "./QuestionWritingText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports